

































import { Component, Prop, Vue } from 'vue-property-decorator';
import getValidationRules from '@/commons/formFieldValidationRules';
import { AddressAttribute, QuoteAddress } from '@/store/models';
import store from '@/store';
import FieldTooltip from '@/components/Address/FieldTooltip.vue';

@Component({
    components: {
        FieldTooltip,
    },
})
export default class FormInputField extends Vue {
    @Prop() public address!: QuoteAddress;
    @Prop() public addressAttribute!: AddressAttribute;
    @Prop() public modelValue!: string;

    get isFieldRequired() {
        if (this.addressAttribute.code === 'fiscaleitalia_fiscalcode') {
            return true;
        }

        return this.addressAttribute.required;
    }

    get validationRules() {
        return getValidationRules(this.addressAttribute, this.address);
    }

    get streetFieldTooltip(): string {
        return store.state.options.customer.streetFieldTooltip;
    }

    get showTooltip(): boolean {
        if (this.addressAttribute.code === 'street') {
            return !!this.streetFieldTooltip;
        }

        return false;
    }

    public updateModelValue(e: any) {
        this.$emit('updateModelValue', [e.target.value, this.addressAttribute.code]);
    }
}
